import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

async function activateAccount(payload) {
  const response = await apiClient.post("/api/v1/auth/users/activation/", payload);
  return response.data;
}

function useActivateAccount() {
  return useMutation({ mutationFn: activateAccount });
}

export { useActivateAccount };
